import { RootState } from '@/app/reducers'
import { IS_IN_MAINTENANCE_KEY } from '@/constants/utils'
import { useSelector } from 'react-redux'

export function useIsInMaintenance(): boolean {
  return useSelector((state: RootState) => Boolean(state.remoteConfig.values[IS_IN_MAINTENANCE_KEY]))
}
